import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/independent-research", label: "Independent Research" },
  { to: "/for-research-teams", label: "For Research Teams" },
  { to: "/for-smes", label: "For SMEs" },
  { to: "/about", label: "About" },
  { to: "/articles", label: "Articles" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/80 border-b border-silver/40" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
          <span className="w-2.5 h-2.5 bg-acid rounded-full group-hover:scale-125 transition-transform" />
          <span className="font-mono-sci text-sm tracking-tight text-ink font-medium">
            SYSTEMS<span className="text-blue-gray">BEYOND</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.slice(1, 6).map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-[13px] tracking-tight transition-colors hover:text-ink ${
                pathname === n.to ? "text-ink" : "text-dark-gray"
              }`}
            >
              {n.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="nav-book-consultation"
            className="text-[13px] font-medium bg-charcoal text-white px-5 py-2.5 border border-transparent hover:border-acid transition-all"
          >
            Book a Consultation
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-ink"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-b border-silver/40 px-6 py-4 flex flex-col gap-1">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="py-2.5 text-sm text-dark-gray border-b border-silver/30 last:border-0"
            >
              {n.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
